import { render, staticRenderFns } from "./RetiredModal.vue?vue&type=template&id=627e118c&scoped=true"
import script from "./RetiredModal.vue?vue&type=script&lang=js"
export * from "./RetiredModal.vue?vue&type=script&lang=js"
import style0 from "./RetiredModal.vue?vue&type=style&index=0&id=627e118c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627e118c",
  null
  
)

export default component.exports